/** * * Asynchronously loads the component for
Why Choose VLE Mobile
* */ import { lazyLoad } from "utils/loadable";
export const WhyChooseVLEMobile = lazyLoad(
  () => import("./index"),
  (module) => module.WhyChooseVLEMobile
);
